const colors = [
  'YlOrRd',
  'YlOrBr',
  'YlGnBu',
  'YlGn',
  'Reds',
  'RdPu',
  'Purples',
  'PuRd',
  'PuBuGn',
  'PuBu',
  'OrRd',
  'Oranges',
  'Greys',
  'Greens',
  'GnBu',
  'BuPu',
  'Blues',
  'Set3',
  'Set2',
  'Set1',
  'Pastel2',
  'Pastel1',
  'Paired',
  'Dark2',
  'Accent',
  'Spectral',
  'RdYlGn',
  'RdYlBu',
  'RdGy',
  'RdBu',
  'PuOr',
  'PRGn',
  'PiYG',
  'BrBg',
]

export { colors }
